import PropTypes from '../_util/vue-types';

var SelectPropTypes = {
  value: PropTypes.array,
  defaultValue: PropTypes.any,
  className: PropTypes.string,
  open: PropTypes.bool,
  maxTagTextLength: PropTypes.number,
  maxTagCount: PropTypes.number,
  maxTagPlaceholder: PropTypes.any,
  displayRender: PropTypes.func,
  choiceTransitionName: PropTypes.string,
  clearIcon: PropTypes.any,
  inputIcon: PropTypes.any,
  removeIcon: PropTypes.any,
  placeholder: PropTypes.any,
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  allowClear: PropTypes.bool
};
export default SelectPropTypes;